import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import T from 'T'
import PropTypes from 'prop-types'

const BillingPeriodOptionTooltip = ({ isLocked, children, invoiceDate }) => {
  if (!isLocked) {
    return children
  }

  return (
    <Tooltip placement="top" arrow title={T.UNCHECK_LATE_FEES_TO_INCLUDE_PREVIOUS_PERIODS} key={`billing-period-${invoiceDate}`}>
      <span>{children}</span>
    </Tooltip>
  )
}

BillingPeriodOptionTooltip.propTypes = {
  isLocked: PropTypes.bool,
  children: PropTypes.node,
  invoiceDate: PropTypes.string,
}

export default BillingPeriodOptionTooltip
